import { TwoButtonModalStyles } from "@insite/content-library/Components/TwoButtonModal";
import { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

const modalBodyCss = (boxShadow: string) => {
    return css`
        height: auto;
        max-height: calc(100% - 90px);
        margin: 45px;
        max-width: 700px;
        box-shadow: ${boxShadow};
    `;
};
const mobileModalBodyCss = (boxShadow: string) => {
    return css`
        height: auto;
        margin: 25px;
        max-width: 100%;
        max-height: calc(100% - 50px);
        box-shadow: ${boxShadow};
    `;
};

const buttonCss = css`
    width: 270px;
    height: 64px;
    margin-bottom: 20px;
    letter-spacing: 0.27px;
`;

const mobileButtonCss = css`
    width: 125px;
    height: 45px;
    margin-bottom: 20px;
    letter-spacing: 0.27px;
`;

class Constants {
    static readonly Actions = class {
        static readonly BeginLoadProductConfig: string = "Custom/ProductConfig/BeginLoadProductConfig";
        static readonly CompleteLoadProductConfig: string = "Custom/ProductConfig/CompleteLoadProductConfig";
        static readonly RemoveProductConfig: string = "Custom/ProductConfig/RemoveProductConfig";
        static readonly BeginUpdateProductConfig: string = "Custom/ProductConfig/BeginUpdateProductConfig";
        static readonly CompleteUpdateProductConfig: string = "Custom/ProductConfig/CompleteUpdateProductConfig";
        static readonly UpdatePlaceOrderParameter: string = "Custom/PlaceOrder/UpdatePlaceOrderParameter";
        static readonly ResetPlaceOrderParameter: string = "Custom/PlaceOrder/ResetPlaceOrderParameter";
        static readonly BeginLoadExternalProvidersWithReturn: string =
            "Custom/Pages/SignIn/BeginLoadExternalProvidersWithReturn";
        static readonly CompleteLoadExternalProvidersWithReturn: string =
            "Custom/Pages/SignIn/CompleteLoadExternalProvidersWithReturn";
        static readonly CompleteSetAddToListModalIsOpen: string =
            "Custom/AddToListModal/CompleteSetAddToListModalIsOpen";
    };

    static readonly Styles = class {
        static readonly modalStyles: TwoButtonModalStyles = {
            modal: {
                // size: 770,
                cssOverrides: {
                    scrim: css`
                        background: rgb(242, 245, 247, 0.88);
                    `,
                    modalBody: css`
                        ${({ theme }) =>
                            breakpointMediaQueries(theme, [
                                mobileModalBodyCss(theme?.shadows[3]),
                                mobileModalBodyCss(theme?.shadows[3]),
                                mobileModalBodyCss(theme?.shadows[3]),
                                modalBodyCss(theme?.shadows[3]),
                                modalBodyCss(theme?.shadows[3]),
                            ])}
                        overflow: hidden;
                    `,
                    modalTitle: css`
                        border-top: 4px solid ${getColor("danger.main")};
                        border-bottom: none;
                    `,
                    modalContent: css`
                        font-size: 16px;
                        line-height: 28px;
                        letter-spacing: 0;
                        margin-bottom: 20px;
                        width: 100%;
                        white-space: pre-wrap;
                        overflow-y: auto;
                    `,
                    titleButton: css`
                        background: transparent !important;
                    `,
                },
                headlineTypographyProps: {
                    variant: "h3",
                    weight: "bold",
                    lineHeight: "32px",
                    css: css`
                        letter-spacing: 1px;
                    `,
                },
                closeButtonIconProps: {
                    size: 16,
                },
            },
            messageText: {
                css: css`
                    font-size: 16px;
                    line-height: 28px;
                    letter-spacing: 0;
                    margin-bottom: 20px;
                    width: 100%;
                    white-space: normal;
                `,
            },
            buttonsGridItem: {
                css: css`
                    justify-content: space-around;
                `,
            },
            submitButton: {
                variant: "secondary",
                color: "secondary",
                typographyProps: {
                    color: "text.main",
                    size: 16,
                    lineHeight: "19px",
                    weight: 600,
                },
                css: css`
                    ${({ theme }) =>
                        breakpointMediaQueries(theme, [
                            mobileButtonCss,
                            mobileButtonCss,
                            mobileButtonCss,
                            buttonCss,
                            buttonCss,
                        ])}
                `,
            },
            cancelButton: {
                variant: "secondary",
                typographyProps: {
                    color: "text.main",
                    size: 16,
                    lineHeight: "19px",
                    weight: 600,
                },
                css: css`
                    ${({ theme }) =>
                        breakpointMediaQueries(theme, [
                            mobileButtonCss,
                            mobileButtonCss,
                            mobileButtonCss,
                            buttonCss,
                            buttonCss,
                        ])}
                `,
            },
        };

        static readonly pageStyles: MobiusPageProps = {
            css: css`
                max-width: 100%;
                position: relative;
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            padding: 25px;
                        `,
                        null,
                        null,
                        css`
                            padding: 100px;
                        `,
                        css`
                            padding: 100px 235px;
                        `,
                    ]);
                }}
            `,
        };

        static readonly visuallyHiddenStyles: InjectableCss = {
            css: css`
                clip: rect(0 0 0 0);
                clip-path: inset(50%);
                height: 1px;
                overflow: hidden;
                position: absolute;
                white-space: nowrap;
                width: 1px;
            `,
        };
    };
}

export default Constants;
